import {get} from './common';

export const loadPnP = async (locale, catalog) => {
    let query = `{ pnp(catalog: ${catalog}, language: ${locale.toUpperCase()}) { title subtitle hint image imageWide link id type }}`;

    let result = await get(
        `https://cnapp-graph-ql.dmti.cloud/?query=${encodeURI(query)}`,
    );

    if (result.data.pnp) {
        return result.data.pnp;
    }
    throw new Error('PnP load failed');
};
